module.exports = __webpack_public_path__ + "static/tokr-poster-a5f189436bcefb7f82ff5b04d18e2b38.jpg";